exports.load = function (assetUrl) {
  return {
    patternDefault: assetUrl('media/common_images/defaultline-menuicon.png'), // default first, then alphabetical
    brickLine: assetUrl('media/common_images/brick.png'),
    brickMenu: assetUrl('media/common_images/brick-menuicon.png'),
    candycaneLine: assetUrl('media/common_images/candycane.png'),
    candycaneMenu: assetUrl('media/common_images/candycane-menuicon.png'),
    dashLine: assetUrl('media/common_images/dashline.png'),
    dashMenu: assetUrl('media/common_images/dashline-menuicon.png'),
    diamondLine: assetUrl('media/common_images/diamond.png'),
    diamondMenu: assetUrl('media/common_images/diamond-menuicon.png'),
    dotLine: assetUrl('media/common_images/dotline.png'),
    dotMenu: assetUrl('media/common_images/dotline-menuicon.png'),
    flowerPinkLine: assetUrl('media/common_images/flower-pink.png'),
    flowerPinkMenu: assetUrl('media/common_images/flower-pink-menuicon.png'),
    flowerPurpleLine: assetUrl('media/common_images/flower-purple.png'),
    flowerPurpleMenu: assetUrl(
      'media/common_images/flower-purple-menuicon.png'
    ),
    flowerYellowLine: assetUrl('media/common_images/flower-yellow.png'),
    flowerYellowMenu: assetUrl(
      'media/common_images/flower-yellow-menuicon.png'
    ),
    heartPinkLine: assetUrl('media/common_images/heart-pink.png'),
    heartPinkMenu: assetUrl('media/common_images/heart-pink-menuicon.png'),
    lightningLine: assetUrl('media/common_images/lightning.png'),
    lightningMenu: assetUrl('media/common_images/lightning-menuicon.png'),
    pawprintLine: assetUrl('media/common_images/pawprint.png'),
    pawprintMenu: assetUrl('media/common_images/pawprint-menuicon.png'),
    rainbowLine: assetUrl('media/common_images/rainbow.png'),
    rainbowMenu: assetUrl('media/common_images/rainbow-menuicon.png'),
    ropeLine: assetUrl('media/common_images/rope.png'),
    ropeMenu: assetUrl('media/common_images/rope-menuicon.png'),
    smileyLine: assetUrl('media/common_images/smiley.png'),
    smileyMenu: assetUrl('media/common_images/smiley-menuicon.png'),
    smokeLine: assetUrl('media/common_images/smoke.png'),
    smokeMenu: assetUrl('media/common_images/smoke-menuicon.png'),
    smoke2Line: assetUrl('media/common_images/smoke2.png'),
    smoke2Menu: assetUrl('media/common_images/smoke2-menuicon.png'),
    spikyLine: assetUrl('media/common_images/spiky.png'),
    spikyMenu: assetUrl('media/common_images/spiky-menuicon.png'),
    squigglyLine: assetUrl('media/common_images/squiggly.png'),
    squigglyMenu: assetUrl('media/common_images/squiggly-menuicon.png'),
    swirlyLine: assetUrl('media/common_images/swirlyline.png'),
    swirlyMenu: assetUrl('media/common_images/swirlyline-menuicon.png'),
    swirly2Line: assetUrl('media/common_images/swirlyline2.png'),
    swirly2Menu: assetUrl('media/common_images/swirlyline2-menuicon.png'),
    tiretrackLine: assetUrl('media/common_images/tiretrack.png'),
    tiretrackMenu: assetUrl('media/common_images/tiretrack-menuicon.png'),
    traintrackLine: assetUrl('media/common_images/traintrack.png'),
    traintrackMenu: assetUrl('media/common_images/traintrack-menuicon.png'),
    waterLine: assetUrl('media/common_images/water.png'),
    waterMenu: assetUrl('media/common_images/water-menuicon.png'),
  };
};
